import { Col, Input, Row } from "reactstrap";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton";
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";

const InviteNewUser = () => {
  return (
    <div>
      <YellowHeaderWrapper title={"Invite New User"}>
        <Row className="g-0 row-gap-1 align-items-center">
          <Col lg={3} xxl={2}>Name:</Col>
          <Col lg={6} xxl={4}>
            <Input placeholder="Enter name of the product" />
          </Col>
        </Row>
        <Row className="g-0 row-gap-1 align-items-center">
          <Col lg={3} xxl={2}>Email:</Col>
          <Col lg={6} xxl={4}>
            <Input placeholder="Enter name of the product" />
          </Col>
        </Row>
        <Row className="g-0 row-gap-1 align-items-center">
          <Col lg={3} xxl={2}>Role:</Col>
          <Col lg={6} xxl={4}>
            <div className="border border-subtle-secondary rounded p-2">
              <CustomDropdown title={"Choose from dropdown menu"} muted />
            </div>
          </Col>
        </Row>
        <Row className="g-0 row-gap-1 align-items-center">
          <Col lg={3} xxl={2}>Password:</Col>
          <Col lg={6} xxl={4}>
            <Input placeholder="Enter password" />
          </Col>
        </Row>
        <div className="text-center my-3">
          <PrimaryButton name={"Send Invitation"} />
        </div>
      </YellowHeaderWrapper>
    </div>
  );
};

export default InviteNewUser;